import React from "react";
import { useFormContext } from "react-hook-form";
import SurveyFormField from "../../../../shared/components/surveyFormField/SurveyFormField";
import CheckMark from "../../../../assets/icons/auth-form/check-mark.png";
import CrossMark from "../../../../assets/icons/auth-form/cross-mark.svg";
import DoesntMatter from "../../../../assets/icons/auth-form/doesnt-matter.svg";
import { getOptionsFromEnums } from "../../../../shared/utility";
import { preferenceEnums } from "../../../../system/global-enums";
import { EMPTY_STRING } from "../../../../constants";

const options = getOptionsFromEnums(preferenceEnums.DECISION_CHOICES);
const TaxPreference = () => {
  const {
    formState: { errors },
  } = useFormContext();
  return (
    <div>
      <div className="question-heading">
        Would you like to live in a tax free country?
      </div>
      {errors.taxFreeCountry && (
        <div className="error">{errors.taxFreeCountry.message}</div>
      )}
      <div className="form-fields">
        {options.map((option, index) => (
          <SurveyFormField
            key={index}
            name="taxFreeCountry"
            variant="radio"
            label={option.label}
            value={option.value}
            endAdornment={
              <div className="position-absolute marks-adornment">
                <img
                  src={
                    Number(option.value) === 1
                      ? CheckMark
                      : Number(option.value) === 2
                      ? CrossMark
                      : DoesntMatter
                  }
                  alt={EMPTY_STRING}
                />
              </div>
            }
          />
        ))}
      </div>
    </div>
  );
};

export default TaxPreference;
